import React from "react";
import { Link } from "react-router-dom";

function Erreur() {
  return (
    <div className={`wrapSectionPage`}>
      <div className="entetePage fond1">
        <div className="textItem">
          <h1>ERREUR 404</h1>
          <p>OOPS!</p>
        </div>
      </div>
      <div className="rowText">
        <div className="centre texte">
          Vous vous êtes perdu! Pas de panique!
          <br />
          <br />
          <Link to="/">Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}

export default Erreur;
